import type { IPermission, IRole } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { orderBy, sortBy } from 'lodash-es';

import { getAllPermissions, getAllRoles } from '@/api/authz.api';
import { withLoading } from '@/shared/helpers';

export const useRoles = ({ sortBy = 'name', sortDirection = 'asc' }: { sortBy?: string; sortDirection?: boolean | 'asc' | 'desc' } = {}) => {
    return useQuery(
        ['roles'],
        async (): Promise<IRole[]> =>
            withLoading(async () => {
                return orderBy(await getAllRoles(), sortBy, [sortDirection]);
            }),
        {},
    );
};

export const usePermissions = () => {
    return useQuery(
        ['/permissions'],
        async (): Promise<IPermission[]> =>
            withLoading(async () => {
                return [...Array.from(new Set(sortBy(await getAllPermissions())))];
            }),
        {},
    );
};
